<template>
  <div v-if="error"
       class="server-error-banner"
       role="alert"
  >
    <div class="server-error-banner__body">
      <div class="server-error-banner__title">
        Server Error<span v-if="error.status"> ({{ error.status }})</span>
      </div>
      <div class="server-error-banner__message">
        通信に失敗しました。時間をおいて再度お試しください。
      </div>
    </div>
    <button type="button"
            class="server-error-banner__reload"
            @click="reload"
    >
      再読み込み
    </button>
    <!-- 調査用にレスポンス body を画面非表示で埋め込む (ユーザーには表示しない)。
         内部エラー情報が DOM に残らないよう本番 (pro) では埋め込まない。 -->
    <div v-if="showRawBody"
         aria-hidden="true"
         class="server-error-banner__raw"
         data-server-error-body
    >{{ error.body }}</div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const apiErrorState = useApiErrorState();
const error = computed(() => apiErrorState.state.value);

// 調査用の生レスポンス body は本番 (pro) では DOM に埋め込まない (内部エラー情報の漏洩防止)。
// 検証環境 (st / pro-staging / development) でのみ調査用に残す。
const circlemsConfig = useCirclemsConfig();
const showRawBody = computed(() => circlemsConfig.get().appEnv !== "pro");

const reload = () => {
  apiErrorState.clear();
  if (import.meta.client) {
    window.location.reload();
  }
};
</script>

<style scoped lang="scss">
.server-error-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background-color: rgb(var(--v-theme-errorDeep));
  color: rgb(var(--v-theme-on-error));
  box-shadow: var(--v-elevation-2);

  &__body {
    flex: 1 1 auto;
    min-width: 0;
  }
  &__title {
    font-weight: bold;
    font-size: 16px;
  }
  &__message {
    font-size: 13px;
    opacity: 0.9;
  }
  &__reload {
    flex: 0 0 auto;
    padding: 6px 14px;
    border: 1px solid rgb(var(--v-theme-on-error));
    border-radius: 9999px;
    background: transparent;
    color: rgb(var(--v-theme-on-error));
    cursor: pointer;
    font-size: 13px;
  }
  // body は調査用に DOM へ残すが画面には出さない
  &__raw {
    display: none;
  }
}
</style>
